import { RouteLocationNormalized, Router } from 'vue-router'

/**
 * Navigates to the fallback route defined in route.meta.fallbackRoute.
 * Falls back to 'partner-sparepart-search' if no fallback is configured.
 */
export function navigateToFallbackRoute(router: Router, route: RouteLocationNormalized) {
    const fallback = route.meta.fallbackRoute
    if (typeof fallback === 'function') {
        router.replace(fallback(route))
    } else if (typeof fallback === 'string') {
        router.replace({ name: fallback })
    } else {
        router.replace({ name: 'partner-sparepart-search' })
    }
}
